<template>
    <div>
        <div class="contain">
            <img class="imgs" src="../../../assets/c35/image.png" ref="secondImage" />
            <img class="imgs" src="../../../assets/c35/image58.png" />
            <img class="imgs" src="../../../assets/c35/image59.png" />
            <img class="imgs" src="../../../assets/c35/image60.png" />

            <div class="video-wrap" style="margin-top:142px">
              <iframe id="ytplayer" class="video-yt" type="text/html" src="https://www.youtube.com/embed/7CRGDk8ArOg?si=rVZSSz7kBHG8Y_iT&autoplay=1&mute=1&controls=0&loop=1&rel=0" title="YouTube video player" frameborder="0" allowfullscreen noresize></iframe>
            </div>

            <img class="imgs" src="../../../assets/c35/image61.png" />
            <img class="imgs" src="../../../assets/c35/image62.png" />
            <img class="imgs" src="../../../assets/c35/image63.png" />
            <img class="imgs" src="../../../assets/c35/image64.png" />
            <img class="imgs" src="../../../assets/c35/image65.png" />
            <img class="imgs" src="../../../assets/c35/image66.png" />
            <img class="imgs" src="../../../assets/c35/image67.png" />
            <img class="imgs" src="../../../assets/c35/image82.png" />
            <img class="imgs" src="../../../assets/c35/image-1.png" />
            <img class="imgs" src="../../../assets/c35/image84.png" />
            <img class="imgs" src="../../../assets/c35/image85.png" />
            <img class="imgs" src="../../../assets/c35/image86.png" />

            <div class="video-wrap">
              <iframe id="ytplayer" class="video-yt" type="text/html" src="https://www.youtube.com/embed/Vu0Ns4gC3YA?si=Z5pLaxLD64cRwGj2&autoplay=1&mute=1&controls=0&loop=1&rel=0" title="YouTube video player" frameborder="0" allowfullscreen noresize></iframe>
            </div>

            <img class="imgs" src="../../../assets/c35/image88.png" />
            <img class="imgs" src="../../../assets/c35/image89.png" />
            <img class="imgs" src="../../../assets/c35/image90.png" />
            <img class="imgs" src="../../../assets/c35/image91.png" />
            <img class="imgs" src="../../../assets/c35/image92.png" />

            <a @click="selfDeepLink" style="cursor: pointer;" :class="['bottom-float-cta', { scrolled: isScrolled }]">
                검사 신청하러 가기
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'c35',
    data: function()
    {
        return {
            isScrolled: false,
            abx_tid: null,
            isInApp: false
        }
    },
    methods: {
      deepLink: function()
      {
        window.location.href = 'soldoc://home/search?departmentId=26?serviceType=CONTACTLESS?type=DEPARTMENT?after-login';
      },
      selfDeepLink() {
        if(this.isInApp)
        {
          this.deepLink();
          return;
        }

        if (!navigator.userAgent.match(/Android/i) && !navigator.userAgent.match(/iPhone|iPad/i)) {
            window.location.href = 'https://event.soldoc.co.kr/';
            return;
        }

        if (!wcs_add) var wcs_add={};
            window.wcs_add = {wa:"s_4b46bc66587"}; //윈도우 객체 선언
            if (!_nasa) var _nasa={};
            if(window.wcs){
                wcs.inflow();
                wcs_do();
            }
        if(window.wcs){
            if(!wcs_add) var wcs_add = {};
            window.wcs_add = {wa:"s_4b46bc66587"}; //윈도우 객체 선언
            var _conv = {};
                _conv.type = 'lead';
            wcs.trans(_conv);
        }

        // 앱의 스키마 URL
        var appSchemeURL = 'soldoc://home/search?departmentId=26?serviceType=CONTACTLESS?type=DEPARTMENT?after-login';
        // 안드로이드와 iOS 마켓 URL
        var androidMarketURL = 'https://play.google.com/store/apps/details?id=com.soldocapp';
        var iosMarketURL = 'https://apps.apple.com/kr/app/soldoc-%EB%B9%84%EB%8C%80%EB%A9%B4%EC%A7%84%EB%A3%8C-%EC%86%8C%EB%B9%84%EC%9E%90%EB%A7%8C%EC%A1%B1%EC%A7%80%EC%88%98-1%EC%9C%84/id1667730511';

        if(this.abx_tid !== undefined) {
            appSchemeURL += `&abx_tid=${this.abx_tid}`;
            // Google Play 스토어 링크
            androidMarketURL += `&referrer=abx_tid%3D${this.abx_tid}`;
            //appstore 스토어 링크
            iosMarketURL += `?&referrer=abx_tid%3D${this.abx_tid}`;
        }

        // 리다이렉트를 체크할 시간 간격
        var timeoutMs = 2000;

        // 앱 실행 시도
        window.location.href = appSchemeURL;

        // 2초 후에 페이지 가시성 체크
        setTimeout(function() {
            if (document.visibilityState === 'visible') {
                // 사용자의 기기에 따라 적절한 마켓으로 리다이렉트
                if (navigator.userAgent.match(/Android/i)) {
                    window.location.href = androidMarketURL;
                } else if (navigator.userAgent.match(/iPhone|iPad/i)) {
                    window.location.href = iosMarketURL;
                }
                else
                {
                    window.location.href = 'https://event.soldoc.co.kr/';
                }
            }
        }, timeoutMs);
      },
      handleScroll() {
        const secondImage = this.$refs.secondImage;
        const rect = secondImage.getBoundingClientRect();
        this.isScrolled = rect.top <= window.innerHeight - 1415;
      },
    },
    mounted() {
      this.isInApp = this.$route.query.inapp;
      if(this.isInApp === null || this.isInApp === undefined || this.isInApp !== 'true')
      {
        this.isInApp = false;
      }
      else
      {
        this.isInApp = true;
      }

      
      function getAbxTidParameter() {
        const params = new URLSearchParams(window.location.search);
        return params.get('abx_tid') || true;
      }
      this.abx_tid = getAbxTidParameter();

      window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
    },
}
</script>

<style scoped>
    .contain{
        width: 100%;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        min-width: 800px;
    }
    .contain .sr-only {
        position: absolute;
        left: -9999px;
        width: 1px;
        height: 1px;
        margin: 0 !important;
        font-size: 0;
        line-height: 0;
        overflow: hidden;
    }
    .bottom-float-cta {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        bottom: 35px;
        width: 712px;
        height: 90px;

        visibility: hidden;
        opacity: 0;
        transition: 0.3s ease;
        z-index: 50;
        font-size: 32px;
        font-weight: 600;
        line-height: 32px;
        color: #fff;
        text-decoration: none;
        border-radius: 0.7rem;
        background-color:#000;
        box-shadow: 0 0.237rem 0.948rem 0 rgba(0, 0, 0, 0.10);
    }

    .bottom-float-cta.scrolled {
      visibility: visible;
      opacity: 1;
    }

    .video-wrap {
      position: relative;
      width: 100%;
      height: 0;
      /* 16:9 비율 */
      padding-bottom: 56.25%;
      overflow: hidden;
    }
    .video-wrap iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    @media screen and (min-width: 800px) {
      .video-wrap {
        width: 800px;
        height: 450px;
        padding-bottom:0;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/pc_view/contents/c35.vue